import { useState } from 'react';

import { ActionButton } from 'commonComponents/ActionButton';

import { type UserDetails } from 'api/users';
import { DeleteIcon } from 'icons';
import { ROLE_DEFINITIONS } from 'roles/definitions';
import { RoleDependentComponent } from 'roles/RoleDependentComponent';

import { UserDeleteDialog } from './UserDeleteDialog';

export function UserDeleteButton({ user }: { user: UserDetails }) {
    const [open, setOpen] = useState(false);

    if (user.userType === 'Administrator') {
        return null;
    }

    return (
        <>
            <RoleDependentComponent
                userRole={ROLE_DEFINITIONS.Administrator}
                component={ActionButton}
                onClick={() => setOpen(true)}
                color="secondary"
                iconClass={DeleteIcon}
                title="Delete"
                variant="contained"
            />
            <UserDeleteDialog
                open={open}
                onClose={() => {
                    setOpen(false);
                }}
                userId={user.id}
            />
        </>
    );
}
